// Force 1 product per row on mobile for Shoptimized
function forceShoptimizedMobileGrid() {
  if (window.innerWidth <= 768) {
    // COLLECTION GRID
    var collectionItems = document.querySelectorAll('.collection-grid .grid__item, .collection-grid .product-grid-item, .collection-grid .product-item');
    collectionItems.forEach(function(item) {
      item.style.width = '100%';
      item.style.maxWidth = '100%';
      item.style.float = 'none';
      item.style.display = 'block';
      item.style.clear = 'both';
      item.style.marginBottom = '20px';
    });

    // PRODUCT PAGE THUMBNAILS
    var thumbnails = document.querySelectorAll('.product-single__thumbnail, .product-single__thumbnails-item, .thumbnails-slider__slide, .product__thumb-item');
    thumbnails.forEach(function(t) {
      t.style.width = '90%';
      t.style.maxWidth = '90%';
      t.style.marginLeft = 'auto';
      t.style.marginRight = 'auto';
      t.style.marginBottom = '12px';
      t.style.display = 'block';
      t.style.float = 'none';
      t.style.clear = 'both';
    });

    // Main product image
    var mainImages = document.querySelectorAll('.product-single__photo-wrapper, .product-single__photo, .product-single__image-container');
    mainImages.forEach(function(m) {
      m.style.width = '95%';
      m.style.marginLeft = 'auto';
      m.style.marginRight = 'auto';
      m.style.marginBottom = '15px';
    });
  }
}

// Run after page fully loads and after theme JS (timeout ensures override)
window.addEventListener('load', function() {
  setTimeout(forceShoptimizedMobileGrid, 100);
});
window.addEventListener('resize', forceShoptimizedMobileGrid);